import React from "react";
import GiftSection from "@/app/(custom-header)/botb-refer-a-friend/components/GiftSection";
import Milestones from "@/app/(custom-header)/botb-refer-a-friend/components/Milestones";
import ReferDraw from "@/app/(custom-header)/botb-refer-a-friend/components/ReferDraw";
import { useBotbRAFContext } from "@/app/(custom-header)/botb-refer-a-friend/context";
import CampaignClosed from "@/app/(custom-header)/botb-refer-a-friend/components/CampaignClosed";

export const ReferAFriendRewards = (): React.ReactNode => {
  const { rafStatus } = useBotbRAFContext();
  const RafEnabled = rafStatus?.endDate * 1000 - new Date().getTime() > 0;
  return (
    <>
      {/*TODO - uncomment and set conditions*/}
      {RafEnabled ? <GiftSection /> : <CampaignClosed />}

      <ReferDraw />
      {rafStatus.referredFriends === rafStatus.maximumInvites ? (
        <></>
      ) : (
        // <ExploreYourDecember />
        <>{RafEnabled ? <Milestones /> : null}</>
      )}
    </>
  );
};
